import { useCallback } from 'react'

import { useCopyValue } from '~/hooks/useCopyValue'
import {
  getSplitsErrorCodeString,
  getSplitsErrorMessage,
} from '~/hooks/useRequests'

export const useHandleInsufficientNativeTokenError = () => {
  const { handleCopy } = useCopyValue()

  const handleInsufficientNativeTokenError = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e: any) => {
      if (getSplitsErrorCodeString(e) === 'INSUFFICIENT_NATIVE_TOKEN') {
        const message = getSplitsErrorMessage(e)
        if (!message) return undefined
        // Message format: "ACCOUNT_NAME (ACCOUNT_ADDRESS) needs ... Please fund the account and try again."
        // Extract the address from the message and return the message without the address
        const accountAddress = message.match(/\((.*?)\)/)?.[1]
        const accountName = message.match(/(\w+)/)?.[0]
        const newMessage = message.replace(` (${accountAddress})`, '')

        if (!accountAddress || !accountName) return undefined
        return {
          description: newMessage,
          duration: 10000,
          action: {
            label: `Copy ${accountName} address`,
            onClick: () => {
              handleCopy(accountAddress)
            },
          },
        }
      }
    },
    [handleCopy],
  )

  return handleInsufficientNativeTokenError
}
